/* Anonymous CTA events for a subscribed Shopify custom/app pixel. */
(()=>{
 const actions={'/pages/inscription-professionnelle':'inscription','/pages/commande-rapide':'commande_rapide','/pages/sur-mesure':'sur_mesure','/pages/contact':'contact'};
 document.addEventListener('click',event=>{
  const link=event.target.closest('a');if(!link)return;
  const url=new URL(link.href,location.href);if(url.origin!==location.origin)return;
  let action=link.dataset.edenAction||actions[url.pathname];
  if(url.pathname.startsWith('/collections/'))action=url.searchParams.get('bio')==='Bio'?'bio':action||'catalogue';
  if(!action)return;
  try{
   if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
   if(typeof window.Shopify?.analytics?.publish!=='function')return;
   const placement=link.dataset.edenPlacement||(link.closest('header')?'header':link.closest('footer')?'footer':'contenu');
   Promise.resolve(window.Shopify.analytics.publish('eden:home_cta_click',{action,placement,path:url.pathname})).catch(()=>{});
  }catch{/* Tracking must never interrupt navigation. */}
 });
})();
